import { render, staticRenderFns } from "./tagManage.vue?vue&type=template&id=263a4e64"
import script from "./tagManage.vue?vue&type=script&lang=js"
export * from "./tagManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports